import { Directive, HostListener, Input } from '@angular/core';

import { SpanishRegulatoryHelperService } from '@frontend/promo-homewidget';
import { CashierNewOptions, CashierService, ContentLink, NativeAppService, NavigationService, WindowRef } from '@frontend/vanilla/core';

@Directive({
    selector: '[onClickOpenLink]',
    standalone: true,
})
export class OpenLinkDirective {
    @Input('onClickOpenLink') button: ContentLink;
    @Input() isCashierButton: boolean = false;
    @Input() doNothing = false;
    @Input() url: string;
    @Input() cashierOptions: CashierNewOptions;
    @Input() dataSendNativeEvent: string;
    @Input() parameters: any = {};

    closeContainerEvent: string = 'closeContainer';
    openCashierEvent: string = 'app:OPEN_CASHIER';

    constructor(
        private nativeApp: NativeAppService,
        private windowRef: WindowRef,
        private navigationService: NavigationService,
        private cashierService: CashierService,
        private spanishRegulatoryHelperService: SpanishRegulatoryHelperService,
    ) {}

    @HostListener('click', ['$event']) onClick() {
        if (this.spanishRegulatoryHelperService.isRiskyPlayer) {
            this.spanishRegulatoryHelperService.showNonComplianceErrorMessage();
        } else if (!this.doNothing) {
            const url = this.button?.url ? this.button?.url : this.url;
            if (this.isCashierButton) {
                this.sendToCashier();
            } else {
                const nativeEvent = this.button?.attributes?.['data-send-native']
                    ? this.button?.attributes['data-send-native']
                    : this.dataSendNativeEvent;
                this.handleNonCashierEvent(url, nativeEvent);
            }
        }
    }

    handleNonCashierEvent(url: string, nativeEvent: string) {
        if (!this.nativeApp.isDownloadClient) {
            this.navigationService.goTo(url);
        } else {
            if (nativeEvent && nativeEvent.trim().length > 0) this.sendNativeEvent(nativeEvent, this.parameters);
            else this.windowRef.nativeWindow.open(url, '_self');
        }
    }

    sendToCashier() {
        if (!this.nativeApp.isDownloadClient) {
            this.cashierService.whenReady.subscribe(() => {
                this.cashierService.goToCashierDeposit(this.cashierOptions);
            });
        } else {
            this.sendNativeEvent(this.openCashierEvent, this.parameters);
        }
    }

    sendNativeEvent(nativeEvent: string, parameters: any) {
        this.nativeApp.sendToNative({ eventName: nativeEvent, parameters });
    }
}
